import Grid from 'components/core/Grid';
import styled from 'styled-components';

export const CenteredGrid = styled(Grid)`
  min-height: '100vh';
`;
